export const debtSuspTrans = {
  D: 'Debtor',
  S: 'Suspense'
}

export const allRI = {
  true: 'Yes',
  false: 'No'
}

export const instalNo = {
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '6'
}
